import React from "react";
import { AutoCompleteField } from "MODULES/shared/components/Forms";
import { Field } from "redux-form";
import { LOT_ID } from "MODULES/Lots/constants";
import { searchLots as search } from "MODULES/Lots/actions";
import { connect } from "react-redux";
import T from "prop-types";

function SelectLot({ searchLots, selectedLot, handleLotSelected }) {
  return (
    <Field
      name={LOT_ID}
      label="Lot Name"
      placeholder="Select Lot"
      component={AutoCompleteField}
      onItemSelected={i => i && handleLotSelected(i)}
      search={searchLots}
      selectedItem={selectedLot}
      formatItem={result => result && result.name}
      required
    />
  );
}

SelectLot.propTypes = {
  handleLotSelected: T.func.isRequired,
  searchLots: T.func.isRequired,
  selectedLot: T.shape({})
};

export default connect(undefined, dispatch => ({
  searchLots: filter => dispatch(search(filter))
}))(SelectLot);



// WEBPACK FOOTER //
// ./app/modules/Lots/shared/SelectLot/SelectLot.jsx